import { Button, Heading, Icon, Text } from '@/atoms';
import { cls } from '@/utils';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { useState } from 'react';
import { t } from 'ttag';
import { EducationFeedbackForm } from '../EducationFeedbackForm';
import styles from './EducationFeedback.module.scss';

interface Props {
	videoId: string;
	onCancel?: (() => void) | null;
}

export const EducationFeedback: React.FC<Props> = ({ videoId, onCancel }) => {
	const [feedBackText, setFeedBackText] = useState<string | null>(null);
	const [showFeedbackButtons, setShowFeedbackButtons] = useState<boolean>(true);
	const [showForm, setShowForm] = useState<boolean>(false);
	const { DataLayer } = usePiwikPro();

	const sendPiwikEvent = (review: 'Positive' | 'Negative') => {
		DataLayer.push({
			event: 'genFortnoxEducationFeedbackClick',
			event_action: review,
			event_category: 'Fortnox Education',
			event_name: `Vimeo-id: ${videoId}`,
		});
	};

	const handleFeedBackClick = (status: 'positive' | 'negative' | 'feedback') => {
		if (status == 'positive') {
			setFeedBackText(t`Tack. Kul att vi kunde hjälpa dig!`);
			setShowFeedbackButtons(false);
			sendPiwikEvent('Positive');
			return;
		}
		if (status == 'negative') {
			setFeedBackText(
				showForm
					? t`Tråkigt att vi inte kunde hjälpa dig.`
					: t`Tråkigt att vi inte kunde hjälpa dig. Berätta gärna mer...`,
			);
			setShowFeedbackButtons(false);
			setShowForm(true);
			sendPiwikEvent('Negative');
			return;
		}
	};

	const cancel = () => {
		if (onCancel) onCancel();
		setFeedBackText(null);
		setShowForm(false);
		setShowFeedbackButtons(true);
	};
	return (
		<>
			<Heading as="div" size="h4" marginBottom="md" title={t`Fick du den hjälp du sökte?`} />
			{feedBackText && (
				<Text as="p" marginBottom="none" bold>
					{feedBackText}
				</Text>
			)}
			{showFeedbackButtons && (
				<div className={styles.btnContainer}>
					<Button
						onClick={() => handleFeedBackClick('positive')}
						variant="filled"
						classNameInner={styles.feedbackBtn}
						id="education-feedback-positive"
						type="button"
					>
						<Icon name="thumbs-up" color="--text-light" size="sm" />
						{t`Ja`}
					</Button>
					<Button
						onClick={() => handleFeedBackClick('negative')}
						variant="outlined"
						classNameInner={styles.feedbackBtn}
						id="education-feedback-negative"
						type="button"
					>
						<Icon name="thumbs-down" color="--text-primary-green" size="sm" />
						{t`Nej`}
					</Button>
				</div>
			)}
			<div className={cls(styles.formContainer, showForm ? styles.show : styles.hidden)}>
				{showForm && <EducationFeedbackForm onCancel={cancel} vimeoId={videoId} />}
			</div>
		</>
	);
};
